import React, { useState, useEffect } from "react";
import { getOrDeleteRequest, getSession } from "../../../utils/utils";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate, useParams } from "react-router-dom";
import MainThemeLayout from "../../../layout/MainThemeLayout";
import DataTableComponent from "../../../components/DataTableComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const PreviewReport = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);

    const navigate = useNavigate();

    const [url, setUrl] = useState('');

    const { date, id, company_id } = useParams();

    const getReport = async (page = 1) => {
        setLoading(true);
        let session = getSession();

        let month = date.split('-')[0];
        let year = date.split('-')[1];

        let uri;

        if ([1, 6].includes(session.type_id)) {
            // uri = `reports/admin/export-report?month=${month}&year=${year}`;
            uri = `reports/export-report/${company_id}?month=${month}&year=${year}&project_id=${id}`;
        }

        if ([4, 5].includes(session.type_id)) {
            uri = `reports/export-report/${session.type_id === 4 ? session.id : session.company.user_id}?month=${month}&year=${year}&project_id=${id}`;
        }

        setUrl(uri);

        window.open(`${process.env.REACT_APP_API_URI}${uri}`, '_blank');

        // navigate(-1);

        setLoading(false);
    };

    useEffect(() => {
        getReport();
    }, []);

    // return (
    //     <MainThemeLayout>
    //         <div className="px-8 py-6">
    //             <div className="mb-4">
    //                 {/* boton de regresar */}
    //                 <Link to="/Reportes" className="flex items-center text-stone-500 dark:text-white cursor-pointer">
    //                     <FontAwesomeIcon icon={faArrowLeft} className="mr-2" />
    //                     <span>Regresar</span>
    //                 </Link>
    //                 <h1 className="text-xl font-semibold text-stone-800 dark:text-white my-2">
    //                     Reporte
    //                 </h1>
    //                 <p className="text-sm text-stone-500 dark:text-white pb-4">
    //                     Detalles del reporte.
    //                 </p>
    //             </div>
    //             {/* <div className='bg-white dark:bg-[#292929] rounded-lg px-5 py-3 w-1/3'>
    //                 <h1 className='py-1 text-base text-start font-semibold dark:text-white'>Usuario: <span className='pl-2 font-normal dark:text-stone-400'>Nuria Melissa Valle Garcia</span></h1>
    //                 <h1 className='py-1 text-base text-start font-semibold dark:text-white'>Fecha: <span className='pl-2 font-normal dark:text-stone-400 !capitalize'>10/03/2025</span></h1>
    //                 <h1 className='py-1 text-base text-start font-semibold dark:text-white leading-8'>Actualización: <span className='pl-2 font-normal dark:text-stone-400'>10/03/2025</span></h1>
    //             </div> */}
    //             <div className="py-4">
    //                 <iframe 
    //                     src={`${process.env.REACT_APP_API_URI}${url}`} width="100%" height="500px"
    //                     sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
    //                 />
    //             </div>
    //         </div>
    //     </MainThemeLayout>
    // );
};

export default PreviewReport;